// GENERATED from design/tokens.json — do not edit by hand.
// Regenerate: make design-tokens
//
// The canon frame contract shared with iOS (Theme.Canon). Values change only
// together with `version` — stale client caches otherwise mix two canons.
export const CANON = {
  version: 2,
  aspect: 2 / 3,
  aspectRatio: [2, 3] as const,
  interocularRatio: 0.2,
  eyeLineY: 0.4,
  width: 1024,
  previewWidth: 256,
  decodeMaxPixel: 2048,
  previewSourceAspect: 3 / 4,
  lock: {
    minInterocularRatio: 0.11,
    maxOutOfBoundsArea: 0.15,
    ambiguousFaceSizeRatio: 0.2,
    landmarkSmoothingFrames: 5,
    visionMaxHz: 15,
  },
} as const;
